import axios from 'axios';

export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL ?? "https://api.brofesional.id",
    // baseURL: "https://api.brofesional.id",
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('TOKEN');
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    }
)

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    }
)